import React from 'react';
import { motion } from 'framer-motion';
import { PlayIcon } from 'lucide-react';
interface PitchActionsProps {
  onPlay: () => void;
  onStoryboard: () => void;
  onConcept: () => void;
  onSignals: () => void;
}
const SPRING = {
  type: 'spring',
  stiffness: 500,
  damping: 30
} as const;
export function PitchActions({
  onPlay,
  onStoryboard,
  onConcept,
  onSignals
}: PitchActionsProps) {
  return <div className="flex flex-wrap items-center gap-2.5" data-id="element-450" data-mp="3diqf9lxly89e">
      <motion.button type="button" onClick={onPlay} whileHover={{
      y: -2
    }} whileTap={{
      scale: 0.98
    }} transition={SPRING} className="inline-flex items-center gap-2.5 whitespace-nowrap rounded-full bg-navy px-7 py-4 text-[15px] font-medium text-paper shadow-[0_18px_40px_-20px_rgba(11,42,74,0.65)] transition-colors duration-150 hover:bg-navy2 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue focus-visible:ring-offset-2" data-id="element-451" data-mp="3dh5kbv7dsnb0">
        <PlayIcon className="h-4 w-4 fill-current" aria-hidden="true" data-id="element-452" data-mp="3s9zaqbo6ynug" />
        Play the Snak
      </motion.button>
      <SecondaryAction onClick={onStoryboard} data-id="element-453" data-mp="380ru0w8k8i3y">Storyboard</SecondaryAction>
      <SecondaryAction onClick={onConcept} data-id="element-454" data-mp="3cy1q2uqgfs0r">Concept &amp; strategy</SecondaryAction>
      <SecondaryAction onClick={onSignals} data-id="element-455" data-mp="3gybx8apzgoh7">What we learn</SecondaryAction>
    </div>;
}
function SecondaryAction({
  children,
  onClick
}: {
  children: React.ReactNode;
  onClick: () => void;
}) {
  return <motion.button type="button" onClick={onClick} whileHover={{
    y: -2
  }} whileTap={{
    scale: 0.98
  }} transition={SPRING} className="inline-flex items-center whitespace-nowrap rounded-full border border-navy/20 px-5 py-4 text-[14px] text-navy/75 transition-colors duration-150 hover:border-navy/55 hover:text-navy focus:outline-none focus-visible:ring-2 focus-visible:ring-blue focus-visible:ring-offset-2" data-id="element-456" data-mp="3qwhzitfpbwml">
      {children}
    </motion.button>;
}